/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type RevokeIdentityProviderConnectionRequestBody = {
  /**
   * Connection ID.
   */
  id: string;
};

/** @internal */
export type RevokeIdentityProviderConnectionRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const RevokeIdentityProviderConnectionRequestBody$outboundSchema:
  z.ZodMiniType<
    RevokeIdentityProviderConnectionRequestBody$Outbound,
    RevokeIdentityProviderConnectionRequestBody
  > = z.object({
    id: z.string(),
  });

export function revokeIdentityProviderConnectionRequestBodyToJSON(
  revokeIdentityProviderConnectionRequestBody:
    RevokeIdentityProviderConnectionRequestBody,
): string {
  return JSON.stringify(
    RevokeIdentityProviderConnectionRequestBody$outboundSchema.parse(
      revokeIdentityProviderConnectionRequestBody,
    ),
  );
}
